@if (isFullscreen) {
  <button class="btn-overlay m-4 absolute top-0 right-0" (click)="onFullscreen()">
    <img src="assets/img/icons/close.svg" class="" alt="Close icon">
  </button>
}